import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { DomainAlerts } from 'features/inventory/domain'
import { DomainsForTable } from 'features/inventory/domain/components/DomainsTable/types/model'
import ActionsCell from './components/ActionsCell'
import { Alert } from './hooks/useGetAlerts'
import { useProductSwitchColumns } from './hooks/useProductSwitchColumns'

type Props = {
  alerts: Alert[]
  count: number
}

export const useColumns = ({ alerts, count }: Props): ColumnDef<DomainsForTable>[] => {
  const { t } = useTranslation('features/domain')
  const productColumns = useProductSwitchColumns({
    products: ['prebidStack', 'refresher', 'viewabilityTools', 'priceGenius', 'unfilledRecovery'],
    tableItemsCount: count,
  })

  return [
    {
      accessorKey: 'name',
      header: t('list.header.domainName'),
      meta: { whiteSpacePre: true },
    },
    ...productColumns,
    {
      accessorKey: 'alerts',
      cell: ({
        row: {
          original: { id: domainId },
        },
      }) => <DomainAlerts alerts={alerts.find(({ id }) => id === domainId)?.alerts ?? []} />,
      header: t('list.header.alerts'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: ({ row }) => <ActionsCell {...row.original} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
